module.exports = __webpack_public_path__ + "media/sounds/incorrect_in_print-843506a0635b4905a6817160cd14fedf.wav";